export default [
    {
        image: require('../images/icon_topinfo@2x.png'),
        name: '独家娱乐资讯'
    },
    {
        image: require('../images/icon_video@2x.png'),
        name: '明星图集，视频，动态'
    },
    {
        image: require('../images/icon_topic@2x.png'),
        name: '有趣话题、粉丝福利'
    },
    {
        image: require('../images/icon_live@2x.png'),
        name: '发布会直播，明星专访'
    }
]
